// This is about me page. 

import React from "react";
import AboutComponent from "../components/AboutComponent";

const About = () => {
  return (
    <div className="pt-[64px] pb-[128px] lg:py-[192px] bg-navbarcolor min-h-[calc(100vh-72px-356px)]">
      <AboutComponent />
    </div>
  );
};

export default About;
